<template>
  <div class="signup--wrap popup__content">
    <div class="signup__try" v-if="!isSuccess">
      <header><h2>
        <i class="icon icon--logo-samsung"></i>
      </h2></header>
      <div v-if="currentStep === 1" class="try__content step1">
        <p class="title">{{ $t('account.signUp.try.title') }}</p>
        <form class="sign-up-form" @submit.prevent="onSubmitStep1">
          <fieldset>
            <ui-input-text :type="'text'"
                           :id="'signupId'"
                           :placeholder="$t('common.validationErrorText.requiredId')"
                           :modelError="modelError.userId"
                           :lower="true"
                           @input="getUserId"
                           @onFocus="modelError.userId = ''">
              {{ $t('common.id') }}
            </ui-input-text>

            <ui-input-text :type="'text'"
                           :id="'signupEmail'"
                           :placeholder="$t('common.placeHolder.enterEmail')"
                           :modelError="modelError.email"
                           :lower="true"
                           @input="getEmail"
                           @onFocus="modelError.email = ''">
              {{ $t('common.email') }}
            </ui-input-text>

            <ui-input-text :type="'password'"
                           :id="'signupPassword'"
                           :placeholder="$t('common.placeHolder.enter6char')"
                           :modelError="modelError.password"
                           @onFocus="modelError.password = ''"
                           @input="getPassword">
              {{ $t('common.password') }}
            </ui-input-text>

          </fieldset>
          <div class="button--wrap">
            <ui-button class="btn__cancel" :buttonType="'reset'" @click="onCloseLayer">
              {{ $t('common.cancel') }}
            </ui-button>
            <ui-button class="btn__register" :buttonType="'submit'" :primary="true">
              {{ $t('common.continue') }}
            </ui-button>
          </div>
        </form>
      </div>

      <div v-else class="try__content step2">
        <p class="title" v-html="$t('account.signUp.try.title2')"></p>
        <form class="sign-up-form" @submit.prevent="onSubmitStep2">
          <fieldset class="fieldset__step2">
            <ui-input-text :type="'text'"
                           :id="'corporation'"
                           :placeholder="$t('common.placeHolder.enterCorporation')"
                           :modelError="modelError.branchName"
                           @onFocus="modelError.branchName = ''"
                           @input="getCorporation">
              {{ $t('common.corporation') }}
            </ui-input-text>

            <div class="select__countrycode--wrap">
              <label for="signUpCountryCode">{{ $t('common.countryCode') }}</label>
              <country-code-selectbox id="signUpCountryCode"
                                      :value="model.siteCodeList"
                                      :modelError="modelError.siteCodeList"
                                      :placeholder="$t('common.placeHolder.enterCountryCode')"
                                      :width="'100%'"
                                      @change="getCountryCode"/>
            </div>

            <div class="select__timezone--wrap">
              <label for="signUpTimezone">{{ $t('common.timezone') }}</label>
              <timezone-selectbox id="signUpTimezone"
                                  :value="model.timezoneName"
                                  :width="'100%'"
                                  @change="selectedTimezone"/>
              <p class="desc">{{ $t('account.signUp.try.form.timezone.desc') }}</p>
            </div>
          </fieldset>
          <div class="button--wrap">
            <ui-button class="btn__cancel" :buttonType="'reset'" @click="onCloseLayer">
              {{ $t('common.cancel') }}
            </ui-button>
            <ui-button class="btn__register" :buttonType="'submit'" :primary="true">
              {{ $t('account.signUp.try.title') }}
            </ui-button>
          </div>
        </form>
      </div>
    </div>

    <div class="signup__done" v-else>
      <i class="icon icon--sent-mail"></i>
      <p class="title">{{ $t('account.signUp.done2.title') }}</p>
      <p class="desc" v-html="$t('account.signUp.done2.desc')">
      <div class="button--wrap">
        <ui-button class="btn__confirm" @click="onCloseLayer">
          {{ $t('common.confirm') }}
        </ui-button>
      </div>
    </div>
  </div>
</template>

<script>
import { signUp, checkDupId, checkDupEmail } from '@/api/user'
import { isValidUserId, isValidEmail, isValidEmailDomain } from '@/libs/validation-helper'
import UiButton from '@/components/ui/UiButton'
import TimezoneSelectbox from '@/components/ui/TimezoneSelectbox'
import CountryCodeSelectbox from '@/components/ui/CountryCodeSelectbox'
import UiInputText from '@/components/ui/UiInputText'

export default {
  components: {
    UiButton,
    TimezoneSelectbox,
    CountryCodeSelectbox,
    UiInputText
  },
  data () {
    return {
      currentStep: 1,
      isSuccess: false, // try, done
      model: {
        userId: '',
        email: '',
        password: '',
        branchName: '',
        siteCodeList: [],
        displayLang: '',
        timezone: '+00:00',
        timezoneName: 'Etc/GMT',
        terms: false,
        signupFrom: 'beusable'
      },
      modelError: {
        userId: '',
        email: '',
        password: '',
        branchName: '',
        siteCodeList: ''
      }
    }
  },
  methods: {
    getUserId (value) {
      this.model.userId = value
    },
    getPassword (value) {
      this.model.password = value
    },
    getEmail (value) {
      this.model.email = value
    },
    getCorporation (value) {
      this.model.branchName = value
    },
    getCountryCode (value) {
      this.modelError.siteCodeList = ''
      this.model.siteCodeList = value
    },
    toggleShowPasswordValue () {
      const targetElement = document.querySelector('#signupPassword')
      if (targetElement.attributes.type.value === 'password') {
        targetElement.setAttribute('type', 'text')
      } else {
        targetElement.setAttribute('type', 'password')
      }
    },
    selectedTimezone (val) {
      this.model.timezone = val.timezone
      this.model.timezoneName = val.timezoneName
    },
    onSubmitStep1 () {
      let isPassedValidationUserId = true
      let isPassedValidationEmail = true
      let isPassedValidationPassword = true
      let isAllPass = true

      if (!this.model.userId) {
        this.modelError.userId = 'requiredId'
        isPassedValidationUserId = false
      } else {
        const formatCheckResult = isValidUserId(this.model.userId)
        if (!formatCheckResult) {
          this.modelError.userId = 'specialCharacterInId'
          isPassedValidationUserId = false
        }
        if (isPassedValidationUserId) this.hideValidationErrorText('userId')
      }

      if (!this.model.email) {
        this.modelError.email = 'requiredEmail'
        isPassedValidationEmail = false
      } else {
        const formatCheckResult = isValidEmail(this.model.email)
        const domainCheckResult = isValidEmailDomain(this.model.email)
        if (!formatCheckResult) {
          this.modelError.email = 'diffFormatEmail'
          isPassedValidationEmail = false
        } else if (!domainCheckResult) {
          this.modelError.email = 'notValidEmail'
          isPassedValidationEmail = false
        }
        if (isPassedValidationEmail) this.hideValidationErrorText('email')
      }

      if (!this.model.password) {
        this.modelError.password = 'requiredPassword'
        isPassedValidationPassword = false
      } else {
        if (this.model.password.length < 6) {
          this.modelError.password = 'passwordInsufficient'
          isPassedValidationPassword = false
        }
        if (isPassedValidationPassword) this.hideValidationErrorText('password')
      }

      for (let item in this.modelError) {
        if (this.modelError[item]) isAllPass = false
      }

      checkDupId({ username: this.model.userId }).then((response) => {
        if (response.okToUse) {
          if (isPassedValidationUserId) {
            this.modelError.userId = ''
          }
        } else {
          if (response.beusablyUser) {
            this.modelError.userId = 'alreadyUsingId'
          } else {
            if (response.active) {
              this.modelError.userId = 'alreadyUsingId'
            } else if (response.approve) {
              this.modelError.userId = 'unApprovedId'
            } else {
              this.modelError.userId = 'unActivatedEmail'
            }
          }
          isAllPass = false
        }

        if (isPassedValidationEmail) {
          checkDupEmail({ email: this.model.email }).then((response) => {
            if (response.okToUse) {
              this.modelError.email = ''
              if (isAllPass) {
                this.currentStep = 2
              }
            } else {
              this.modelError.email = 'alreadyUsingEmail'
            }
          })
        }
      })
    },
    onSubmitStep2 () {
      let isPassedValidationCorporation = true
      let isPassedValidationSiteCode = true
      let isAllPass = true

      if (!this.model.branchName) {
        this.modelError.branchName = 'requiredCorporation'
      } else {
        if (isPassedValidationCorporation) this.hideValidationErrorText('corporation')
      }

      if (!this.model.siteCodeList.length) {
        this.modelError.siteCodeList = 'requiredCountryCode'
      } else {
        if (isPassedValidationSiteCode) this.hideValidationErrorText('countryCode')
      }

      for (let item in this.modelError) {
        if (this.modelError[item]) isAllPass = false
      }

      if (isAllPass) {
        const param = {
          userId: this.model.userId,
          email: this.model.email,
          userPw: this.model.password,
          branchName: this.model.branchName,
          siteCodeList: this.model.siteCodeList,
          timezone: this.model.timezone,
          timezoneName: this.model.timezoneName,
          signupFrom: 'beusable'
        }
        this.isSuccess = true
        signUp(param).then(() => {
          this.isSuccess = true
          this.hideValidationErrorText('all')
        })
        return false
      } else {
        return false
      }
    },
    hideValidationErrorText (value) {
      if (value === 'all') {
        for (let item in this.modelError) {
          this.modelError[item] = ''
        }
      } else {
        this.modelError[value] = ''
      }
    },
    onCloseLayer () {
      this.$emit('closeLayer', true)
    }
  },
  created () {
  }
}
</script>

<style lang="scss" scoped="scoped">
  .signup--wrap {
    @include positionXYcenter;
    border-radius: 14px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    .signup__try {
      width: 720px;
      height: 550px;
      padding: 40px 40px 25px;
      box-sizing: border-box;
      text-align: center;

      h2 i {
        width: 150px;
        height: 25px;
        background-size: 150px 25px;
      }

      .try__content {
        margin-top: 23px;

        .title {
          font-size: 16px;
          font-weight: bold;
          color: #555555;
          margin-top: 32px;
        }

        &.step1 {
          width: 340px;
          margin: 23px auto 0 auto;
        }

        &.step2 {
          width: 486px;
          margin: 23px auto 0 auto;
        }

        .sign-up-form {
          .input--wrap {
            margin-bottom: 7px;
          }

          .button--wrap {
            margin-top: 95px;
          }

          .fieldset__step2 {
            margin-bottom: 48px;
          }

          .select__countrycode--wrap {
            margin-top: 30px;
            text-align: left;
            height: 57px;
            position: relative;
            z-index: 2;

            label {
              display: block;
              font-weight: bold;
              padding-left: 5px;
              margin-bottom: 5px;
              font-size: 13px;
              color: #767676;
            }
            .desc {
              margin-top: 8px;
              margin-left: 6px;
              font-size: 12px;
              line-height: 1.08;
              color: #767676;
            }
          }

          .select__timezone--wrap {
            margin-top: 30px;
            text-align: left;
            height: 57px;
            position: relative;
            z-index: 1;

            label {
              display: block;
              font-weight: bold;
              padding-left: 5px;
              margin-bottom: 5px;
              font-size: 13px;
              color: #767676;
            }
            .desc {
              margin-top: 8px;
              margin-left: 6px;
              font-size: 12px;
              line-height: 1.08;
              color: #767676;
            }
          }

          .button--wrap {
            padding-bottom: 0;
            text-align: center;

            button {
              min-width: 95px;
            }

            .btn__register {
              margin-left: 5px;
            }
          }
        }
      }
    }
    .signup__done {
      width: 430px;
      height: 350px;
      padding: 25px;
      box-sizing: border-box;
      text-align: center;
      .icon--sent-mail {
        margin-top: 25px;
      }
      .title {
        font-size: 20px;
        font-weight: bold;
        color: #444444;
        margin-top: 15px;
      }
      .desc {
        font-size: 14px;
        line-height: 1.43;
        color: #2f2f2f;
        margin-top: 12px;
      }
      .button--wrap {
        margin-top: 40px;
        button {
          margin-left: 5px;
        }
      }
    }
  }
  [lang='ja'] {
    .signup--wrap .signup__try .try__content .content__left .title {
      font-size: 30px;
    }
    .signup--wrap .signup__try .try__content .content__left .desc {
      max-width: 240px;
    }
    .signup--wrap .signup__try .try__content .content__right .sign-up-form .fieldset__step2 {
      margin-bottom: 25px;
    }
    .signup--wrap .signup__try .try__content .content__right .sign-up-form .input__agree--wrap .validation-text.agree {
      left: 0;
    }
  }
</style>
